import { apiErrorToToast } from "@/lib/utils";
import { appealReview } from "@/requests/questionnaries/appeal-review.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useAppealReviewMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: appealReview,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "companies",
          variables.companyId,
          "quiz",
          variables.applicationQuizId,
        ],
      });
    },
  });
};
